import { memo, type ReactNode } from 'react';

interface SwipeableTabsContainerProps {
  children: ReactNode;
}

export const SwipeableTabsContainer = memo(({ children }: SwipeableTabsContainerProps) => {
  // Swipe navigation is intentionally disabled for performance.
  return <>{children}</>;
});

SwipeableTabsContainer.displayName = 'SwipeableTabsContainer';
